import _extends from "@babel/runtime/helpers/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { calculateRem } from '@uie/javascript-style-helpers';
import { TypographyConfig } from '@vds-core/typography';
import { calculateSpacing } from '@vds-core/theme';
var propTypes = {
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  inverted: PropTypes.bool,

  /**
   * @ignore
   * If provided a string of a proper multiplier constant in calculate spacing, a bottom of a margin 4 times the input will render.
   */
  marginBottom: PropTypes.string,

  /**
   * @ignore
   * If provided, an object containing color values in hex will be returned
   */
  colorConfig: PropTypes.object,

  /**
   * @ignore
   * If provided, an object containing font-family, font-size, and line-height will be returned.
   */
  bodyConfig: PropTypes.object,

  /**
   * @ignore
   * Typescale of text within RadioButton.
   */
  typescale: PropTypes.string,

  /**
   * @ignore
   * If provided, a dashed focus state will render RadioButtonIcon will exist.
   */
  focusState: PropTypes.bool,

  /**
   * @ignore
   * If provided, a hover state that thickens the border of the RadioButtonIcon will exist.
   */
  hoverState: PropTypes.bool,

  /**
   * @ignore
   * If provided, the RadioButton will break into a new line at the given string value width.
   */
  maxLabelWidth: PropTypes.string,

  /**
   * @ignore
   * If provided, padding surrounding the RadioButton will render.
   */
  padding: PropTypes.string
};
var defaultProps = {
  disabled: false,
  inverted: false
}; //Make the height the proper 44px, but for every succeeding child:
// - add 2px margin to account for top: -2px on the RadioButtonIcon
// - present in the RadioButtonGroup

/**
 * @ignore
 */

var RadioLabel = /*#__PURE__*/styled.label.withConfig({
  displayName: "RadioLabel",
  componentId: "sc-c86p5f-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  line-height: ", ";\n  font-size: ", ";\n  font-family: ", ";\n  letter-spacing: ", ";\n  max-width: ", ";\n  color: ", "\n    ", ";\n  cursor: pointer;\n"])), function (_ref) {
  var labelText = _ref.labelText;
  return calculateRem(labelText.lineHeight);
}, function (_ref2) {
  var labelText = _ref2.labelText;
  return calculateRem(labelText.fontSize);
}, function (_ref3) {
  var labelText = _ref3.labelText;
  return labelText.fontFamily;
}, function (_ref4) {
  var labelText = _ref4.labelText;
  return calculateRem(labelText.letterSpacing);
}, function (_ref5) {
  var maxLabelWidth = _ref5.maxLabelWidth;
  return maxLabelWidth;
}, function (_ref6) {
  var inverted = _ref6.inverted,
      colorConfig = _ref6.colorConfig;
  return inverted ? colorConfig.white : colorConfig.black;
}, function (_ref7) {
  var disabled = _ref7.disabled,
      inverted = _ref7.inverted,
      colorConfig = _ref7.colorConfig;
  return disabled && "\n    color: ".concat(inverted ? colorConfig.coolGray10 : colorConfig.coolGray3, ";\n    cursor: default;\n  ");
});

var RadioButtonLabel = function RadioButtonLabel(props) {
  var bodyConfig = props.bodyConfig,
      colorConfig = props.colorConfig,
      typescale = props.typescale,
      maxLabelWidth = props.maxLabelWidth,
      disabled = props.disabled,
      inverted = props.inverted;
  var labelText = bodyConfig.getStyles(typescale, 'desktop', typescale === 'VDS' ? 'large' : 'medium');
  return /*#__PURE__*/React.createElement(RadioLabel, _extends({}, props, {
    colorConfig: colorConfig,
    labelText: labelText,
    maxLabelWidth: maxLabelWidth,
    disabled: disabled,
    inverted: inverted
  }));
};

RadioButtonLabel.propTypes = propTypes;
RadioButtonLabel.defaultProps = defaultProps;
export default RadioButtonLabel;